import React from 'react'
import "./Home.scss"
import { motion } from "framer-motion"

const contactMe = () => {
  const email = 'dench327@gmail.com';
  const subject = 'Nice to meet you!';
  const body = 'Hi, I want to get in touch with you.';

  const mailtoUrl = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  window.location.href = mailtoUrl;
};

export const Home = () => {

  return (
    <div className='home flex container'>
      <motion.div
        initial={{ y: '100%', opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="images-container flex">
        <img src="/assets/it-guy.png" alt="" className="it-guy" />
      </motion.div>
      <motion.div
        initial={{ y: '100%', opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="description-container">
        <div className="name-container">
          <h2 className='first-part'>MY NAME IS </h2>
          <h2 className="second-part">Denys Semko!</h2>
        </div>
        <h1 className='position'>I'm a Software Engineer</h1>
        <div className="short-description">
          <p className='description'>
              I'm an accomplished .NET Developer with more than 3 years of professional experience. <br />
              My expertise contains back-end and front-end development using .NET, React/Angular, MSSQL, MongoDb etc. <br />
              I'm seeking to help company develop their product, 
              as well as grow and improve my own skills.
          </p>
        </div>
        <div className="btn-container">
            <button className='get-in-touch-btn' onClick={contactMe}>GET IN TOUCH</button>
        </div>
      </motion.div>
    </div>
  )
}